import PropTypes from 'prop-types';
import { filter, any, isEmpty } from 'ramda';
import Floor from './Floor';
import * as Styled from './Style';
const SeatsSelect = ({
  seats,
  ...otherProps
}) => {
  const firstFloor = filter(any(seat => seat.floor === 0), seats);
  const secondFloor = filter(any(seat => seat.floor === 1), seats);
  const isOldApiSeats = !firstFloor.length && !secondFloor.length;
  const firstFloorBadgeText = secondFloor.length ? I18n.t('pages.checkout.rebooking.seatmap.ground_floor') : '';
  const secondFloorBadgeText = secondFloor.length ? I18n.t('pages.checkout.rebooking.seatmap.upper_floor') : '';
  return /*#__PURE__*/React.createElement(Styled.SeatMapWrapper, {
    isTwoFloor: !isEmpty(secondFloor)
  }, !isEmpty(secondFloor) && /*#__PURE__*/React.createElement(Floor, {
    seats: secondFloor,
    badgeText: secondFloorBadgeText,
    isWheelHidden: isEmpty(secondFloor),
    ...otherProps
  }), /*#__PURE__*/React.createElement(Floor, {
    seats: isOldApiSeats ? seats : firstFloor,
    badgeText: firstFloorBadgeText,
    ...otherProps
  }));
};
SeatsSelect.propTypes = {
  seats: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    number: PropTypes.string,
    type: PropTypes.string,
    floor: PropTypes.number
  })))
};
export default SeatsSelect;